import { Image, Skeleton } from "antd";
import { PrinterOutlined } from "@ant-design/icons";
import React from "react";
import styled from "@emotion/styled";
import { useMediaHandler } from "../../hooks/useMediaHandler";

const StyledImageDiv = styled.div`
  &.loading {
    width: 114px;
    position: relative;
    height: 114px;
    img {
      height: 0px !important;
      width: 0px !important;
    }
  }
  .image-placeholder {
    position: absolute;
    top: 0;
    background: white !important;
  }
`;

const printImage = (src) => {
  const printFrame = document.createElement("iframe");
  printFrame.style.position = "fixed";
  printFrame.style.top = "-10000px";
  printFrame.style.left = "-10000px";
  document.body.appendChild(printFrame);

  const frameDoc = printFrame.contentWindow || printFrame.contentDocument;
  //@ts-ignore
  const doc = frameDoc.document || frameDoc;

  doc.open();
  doc.write(`
    <html>
      <head>
        <title>Print Image</title>
        <style>
          @page {
            margin: 0;
            size: auto;
          }
          
          body {
            margin: 0;
            padding: 0;
            display: flex;
            justify-content: center;
            align-items: center;
          }
          
          img {
            max-width: 100%;
            max-height: 100dvh;
            display: block;
          }
        </style>
      </head>
      <body>
        <img src="${src}" />
      </body>
    </html>
  `);
  doc.close();

  const cleanup = () => {
    try {
      if (printFrame && printFrame.parentNode) {
        printFrame.parentNode.removeChild(printFrame);
      }
    } catch (e) {
      console.error("Cleanup error:", e);
    }
  };

  const img = doc.querySelector("img");
  if (img) {
    img.onload = () => {
      setTimeout(() => {
        try {
          printFrame.contentWindow.focus();
          printFrame.contentWindow.print();
        } catch (e) {
          console.error("Print error:", e);
        }

        setTimeout(cleanup, 500);
      }, 100);
    };

    img.onerror = () => {
      cleanup();
    };
  } else {
    cleanup();
  }

  if (printFrame.contentWindow) {
    printFrame.contentWindow.onafterprint = cleanup;
  }
};

const PrintableImage = ({
  src,
  alt = "image",
  onError,
  isDoc = false,
  ...rest
}) => {
  const { handleError, isLoading, handleLoaded } = useMediaHandler({
    src,
    onError,
  });

  return (
    <StyledImageDiv className={isLoading ? "loading" : ""}>
      <Image
        src={src}
        alt={alt}
        onLoad={handleLoaded}
        onError={handleError}
        preview={{
          toolbarRender: (originalNode) => {
            const customButton = (
              <div
                className="ant-image-preview-actions-action"
                onClick={(e) => {
                  e.stopPropagation();
                  printImage(src);
                }}
                role="button"
                aria-label="Print image"
              >
                <PrinterOutlined />
              </div>
            );

            return React.cloneElement(originalNode, {
              //@ts-ignore
              children: [
                customButton,
                //@ts-ignore
                ...React.Children.toArray(originalNode.props.children),
              ],
            });
          },
        }}
        {...rest}
      />
      {isLoading && (
        <div className="image-placeholder">
          <Skeleton.Image
            active
            style={isDoc ? { width: 56, height: 60 } : {}}
          />
        </div>
      )}
    </StyledImageDiv>
  );
};

export default PrintableImage;
